<template>
    <div class="club" :class="{ loading }" @click="$emit('click')">
        <div v-if="loading" class="loading-skeleton">
            <SvgLoader path="assets/img/skeletons/event-skeleton" />
        </div>
        <div v-else class="main-content" :class="capacityState !== 'EMPTY' ? 'highlight' : ''">
            <div class="col club-title-container">
                <div class="club-image" :style="`background-image: url(${venue.logoUrl});`"></div>
                <div class="text-container">
                    <div class="title copy-l bold" :title="venue.name">{{ venue.name }}</div>
                    <div class="description">
                        <div class="rating">
                            <FeatherIcon
                                v-for="star in 5"
                                :key="star"
                                :class="star <= Math.floor(venue.sourceStarRating) ? 'active' : ''"
                                name="star"
                            />
                        </div>
                        <div class="text copy-m">
                            <div class="fans">{{ kFormatter(venue.sourceFanCount) }} Fans</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col club-genres">
                <Tag v-for="genre in venue.genres" :key="genre" :value="genre" />
            </div>
            <div class="col club-events">
                <div v-if="false" class="rsvp-container">
                    <div class="text copy-m">
                        {{ venue.future_event_count }} {{ $t('venue_overview.club.amount_upcoming_events') }}
                    </div>
                </div>
                <div class="attending-count-container">
                    <div class="text copy-m">
                        {{ text }} {{ $t('venue_overview.club.space.guests') }} ({{ percentage }}%)
                    </div>
                    <ProgressCircular :value="percentage" :radius="10" :stroke-width="5" />
                </div>
                <div v-if="false" class="more-container">
                    <FeatherIcon name="more-horizontal"></FeatherIcon>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Tag from '@/components/Tag'
import FeatherIcon from '@/components/FeatherIcon'
import SvgLoader from '@/components/SvgLoader'
import ProgressCircular from '@/components/ProgressCircular'

export default {
    name: 'Club',
    components: {
        Tag,
        FeatherIcon,
        SvgLoader,
        ProgressCircular,
    },
    props: {
        venue: {
            type: Object,
            required: false,
            default: undefined,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        percentage() {
            if (!this.venue) {
                return 0
            }
            if (this.venue.capacityInUse === 0) {
                return 0
            }

            return Math.floor((this.venue.capacityInUse / this.venue.capacity) * 100)
        },
        capacityState() {
            if (this.percentage < 80) {
                return 'EMPTY'
            } else if (this.percentage >= 80 && this.percentage < 100) {
                return 'ALMOST_FULL'
            } else {
                return 'FULL'
            }
        },
        text() {
            return `${this.venue.capacityInUse} ${this.$t('venue_overview.club.space.of')} ${
                this.venue.capacity ? this.venue.capacity : 0
            } `
            // if (this.capacityState === 'EMPTY') {
            // } else if (this.capacityState === 'ALMOST_FULL') {
            //     return this.$t('venue_overview.club.space.almost_full')
            // } else {
            //     return this.$t('venue_overview.club.space.full')
            // }
        },
    },
    methods: {
        kFormatter(num) {
            return Math.abs(num) > 999
                ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k'
                : Math.sign(num) * Math.abs(num)
        },
    },
}
</script>

<style scoped lang="sass">
.club
    padding: $m $l
    border-radius: 1rem
    cursor: pointer
    overflow: hidden
    width: 100%
    max-width: 100%
    margin-left: -$m
    @include breakpoint('m')
        display: flex
        box-sizing: border-box
        overflow: hidden
        margin-left: 0

        .main-content
            flex-direction: column

    &.loading
        pointer-events: none

    .main-content
        display: flex
        align-items: center

        &.highlight
            .attending-count-container
                .text
                    font-weight: bold

    .more-container
        width: 3rem
        height: 3rem
        background: $gray-1
        display: flex
        align-items: center
        justify-content: center
        border-radius: 99em
        margin-left: $m
        opacity: 0
        transform: scale(0.8)
        +transition(80ms)

        &:hover
            background: darken($gray-1, 5%)

        .feather-icon
            width: 1.8rem

    &:hover
        background: white
        box-shadow: $box-mois

    .col
        flex: 1

        &.club
            &-genres
                white-space: nowrap
                overflow: hidden
                text-overflow: ellipsis
                color: transparent

                .tag
                    display: inline-flex

            &-title-container
                display: flex

                .text-container
                    .fans
                        width: 100px

                    .description
                        display: flex
                        align-items: center

                        .rating
                            display: flex
                            align-items: center

                            ::v-deep .feather-icon
                                width: 18px
                                svg
                                    stroke: $neutral-2

                            .active ::v-deep .feather-icon
                                width: 18px
                                svg
                                    fill: $neutral-2

                        .text
                            display: flex
                            color: $neutral-2

                            .price
                                display: flex
                                align-items: center

                            & > div
                                &:before
                                    content: '·'
                                    margin: 0 $xxs


                    .title
                        white-space: nowrap
                        max-width: 250px
                        text-overflow: ellipsis
                        overflow: hidden
                        padding-right: $l

                    .time
                        color: $neutral-2

                .club-image
                    width: 4.8rem
                    min-width: 4.8rem
                    height: 4.8rem
                    background: $gray-1
                        size: cover
                        position: center
                    border-radius: 8px
                    margin-right: $l


            &-events
                display: flex
                flex: 0
                align-items: center

                .rsvp-container
                    display: flex
                    align-items: center
                    justify-content: flex-end
                    +transition(80ms)

                    .text
                        white-space: nowrap
                        text-align: right

                    .feather-icon.user-icon
                        width: 16px
                        margin-right: $xs

                .attending-count-container
                    display: flex
                    align-items: center
                    justify-content: flex-end
                    margin-right: -$xs
                    +transition(80ms)

                    .text
                        white-space: nowrap
                        text-align: right

                    .feather-icon.user-icon
                        width: 16px
</style>
